import { useQueryClient } from '@tanstack/vue-query';
import * as Sentry from '@sentry/vue';
import { useMutation } from '~/queries/useMutation';
import { unwrapResponse } from '~/utils/unwrapResponse';

export const useUserMapMutation = () => {
	const queryClient = useQueryClient();
	const { $api } = useNuxtApp();

	const mapUser = useMutation({
		mutationKey: ['user-map'],
		mutationFn: async () => $api.GET('/map')
			.then((response) => {
				if (response.response.status === 207) {
					Sentry.withScope((scope) => {
						scope.setFingerprint([
							'API',
							response.response.url,
							String(response.response.status),
						]);
						scope.setTag('status_code', String(response.response.status));
						scope.setTag('endpoint', new URL(response.response.url).pathname);
						scope.setContext('Response Data', response.data || {});
						Sentry.captureException(new Error('/map succeeded only partially', { cause: response.response }));
					});
				}

				return response;
			})
			.then(unwrapResponse),
		onSuccess: () => Promise.all([
			queryClient.invalidateQueries({ queryKey: ['merchants'] }),
			queryClient.invalidateQueries({ queryKey: ['profile'] }),
		]),
	});

	return {
		mapUser,
	};
};
